/**
 * FIFO queue to preserve Orion API calls ordering
 * while sending order drafts on a regular order form
 */
export default class OrdersQueue {
  constructor() {
    // Array to store orders
    this.data = [];
  }

  /**
   * @return {Number} Number of orders in the queue
   */
  size() {
    return this.data.length;
  }

  /**
   * Add an order at first index
   * @param order {object} Order to add
   */
  add(order) {
    this.data.unshift(order);
  }

  /**
   * Returns the oldest order (last index)
   * @return {object} oldest order or undefined if queue is empty
   */
  next() {
    if (!this.data.length > 0) {
      return undefined;
    }

    return this.data[this.data.length - 1];
  }

  /**
   * Remove and returns the oldest order (last index)
   * @return {object} oldest order or undefined if queue is empty
   */
  remove() {
    return this.data.pop();
  }
}



// WEBPACK FOOTER //
// ./src/common/modules/orders-queue.js